import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Header(){
  return (
    <header className="header container" role="banner">
      <NavLink  to="/react-projects/gamerfrog/" className="brand" aria-label="Game Reviews Home">
        <div className="logo">
           <img src={process.env.PUBLIC_URL + '/gamerfrog.svg'} alt="GamerFrog Logo" width="100" height="100" />
        </div>
        <div>
          <h2>GamerFrog Reviews</h2>
          <h3 style={{fontSize:12,color:'var(--muted)'}}>Leap into gaming</h3>
        </div>
      </NavLink >
      <nav className="nav" role="navigation" aria-label="Main">
        <ul className="breadcrumb">
          <li>
            <NavLink
              to="/react-projects/gamerfrog/reviews"
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Reviews
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/react-projects/gamerfrog/new-review"
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Write Review
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}
